export const calendarModals = {
  common: {
    cancel: "Abbrechen",
  },
  arrival: {
    title: "Kalenderregeln",
    loading: "Einstellungen werden geladen…",
    daysTitle: "An- und Abreisetage",
    canArrive: "Gäste können anreisen",
    canDepart: "Gäste können abreisen",
    daysHint:
      "Mit <b>allen ausgewählten Tagen</b> gibt es keine Einschränkungen. Wenn Sie Anreisen nur montags und Abreisen nur sonntags zulassen, dauert jede Buchung genau eine Woche.",
    summaryAny: "Gäste können an jedem Tag an- und abreisen",
    summaryArrival: "Anreise an {n} von 7 Tagen",
    summaryDeparture: "Abreise an {n} von 7 Tagen",
    summaryRestricted: "Eingeschränkt: {detail}",
    cutoffTitle: "Verkauf für heute ab einer bestimmten Uhrzeit schließen",
    cutoffToggle: "Verkauf für denselben Tag automatisch schließen",
    cutoffToggleHint: "Solange dies deaktiviert ist, nehmen Sie Check-ins für heute zu jeder Zeit an.",
    cutoffFrom: "Ab",
    cutoffTz: "Ortszeit Ihrer Unterkunft",
    cutoffTzNow: "dort ist es {time}",
    cutoffHintPre: "Täglich ab ",
    cutoffHintMid: " in ",
    cutoffHintPost:
      " nehmen Sie keine Buchungen mehr für denselben Tag an. Die folgenden Tage bleiben wie gewohnt geöffnet.",
    cutoffSummaryOn: "Der Verkauf schließt täglich um {time}",
    cutoffSummaryOff: "Sie nehmen Check-ins für heute zu jeder Zeit an",
    turnoverTitle: "Vorbereitungszeit",
    turnoverQuestion: "Wie viele Nächte brauchen Sie zwischen einem Gast und dem nächsten?",
    turnoverOptNone: "Keine",
    nights: "{count} Nacht | {count} Nächte",
    custom: "Individuell",
    customLabel: "Nächte",
    customAside: "auf jeder Seite, bis zu 7",
    turnoverSummaryNone: "Gäste können am selben Tag anreisen, an dem andere abreisen",
    turnoverSummarySet: "{nights} zwischen einem Gast und dem nächsten freihalten",
    turnoverLegacySummaryAfter: "Gilt derzeit nur nach dem Check-out · speichern, um beide Seiten abzudecken",
    turnoverLegacySummaryBefore: "Gilt derzeit nur vor dem Check-in · speichern, um beide Seiten abzudecken",
    turnoverLegacyNoteAfter: "Diese Regel stammt aus der vorherigen Version und blockiert derzeit nur nach dem Check-out, nicht vor dem Check-in. Beim Speichern gilt sie für beide Seiten, und wir zeigen Ihnen zuerst, wie viele Nächte geschlossen werden.",
    turnoverLegacyNoteBefore: "Diese Regel stammt aus der vorherigen Version und blockiert derzeit nur vor dem Check-in, nicht nach dem Check-out. Beim Speichern gilt sie für beide Seiten, und wir zeigen Ihnen zuerst, wie viele Nächte geschlossen werden.",
    exampleLabel: "Beispiel",
    exampleCaption: "Eine Buchung mit Anreise am 15. und Abreise am 18.",
    legendStay: "Aufenthalt",
    legendPrep: "Vorbereitung",
    legendFree: "Im Verkauf",
    turnoverMoveHint:
      "Die Sperre verschiebt sich automatisch, wenn sich die Daten ändern, und entfällt, wenn die Buchung storniert wird.",
    impactClosePre: "Damit werden ",
    impactClosePost: " in Ihren Kanälen geschlossen.",
    impactOpenPre: "Damit werden ",
    impactOpenPost: " geöffnet.",
    impactRetry: "Drücken Sie erneut auf „Regeln speichern“, um es anzuwenden.",
    fallbackHost: "Ihrer Unterkunft",
    saving: "Wird gespeichert…",
    applyYes: "Ja, anwenden",
    saveRules: "Regeln speichern",
    loadError: "Die Einstellungen konnten nicht geladen werden.",
    saveSuccess: "Kalenderregeln gespeichert und an Ihre Kanäle gesendet.",
    saveError: "Speichern nicht möglich.",
    saveConfigError: "Die Einstellungen konnten nicht gespeichert werden.",
    linkedTitle: "Verkauf der gesamten Wohnung",
    linkedSummaryOff: "Diese Einheit wird einzeln verkauft",
    linkedSummaryOn: "Verkauft die gesamte Wohnung · enthält {count} Zimmer | Verkauft die gesamte Wohnung · enthält {count} Zimmer",
    linkedSummaryChild: "Teil von {parent}",
    linkedRooms: "{count} Zimmer | {count} Zimmer",
    linkedToggle: "Als gesamte Wohnung des Inserats festlegen",
    linkedToggleHint: "Für die Einheit, die die gesamte Wohnung vermietet. Wählen Sie als Nächstes, welche Zimmer sie umfasst.",
    linkedQuestion: "Welche Zimmer umfasst sie?",
    linkedAll: "Alle auswählen",
    linkedNone: "Alle abwählen",
    linkedIsParent: "Wird bereits als gesamte Wohnung verkauft",
    linkedGuests: "{count} Gast | {count} Gäste",
    linkedExampleCaption: "„{room}“ ist vom 19. bis zum 21. gebucht",
    linkedExampleRoom: "Zimmer 1",
    linkedLegendClosed: "Schließt automatisch",
    linkedHint: "Es funktioniert auch umgekehrt: Wenn die gesamte Wohnung gebucht wird, schließen alle ihre Zimmer. Wird die Buchung storniert oder ändern sich ihre Daten, öffnet sich alles von selbst wieder, auch in Ihren Kanälen. Solange die Buchung besteht, lassen sich diese Sperren nicht von Hand öffnen.",
    linkedChildPre: "Dieses Zimmer gehört zu ",
    linkedChildPost: ". Wenn es gebucht wird, schließt diese gesamte Wohnung für diese Nächte; wird die gesamte Wohnung gebucht, schließt dieses Zimmer von selbst. Sie können das in den Kalenderregeln der gesamten Wohnung ändern.",
    linkedConflicts: "Es gibt bereits {count} Doppelbuchung zwischen der gesamten Wohnung und ihren Zimmern. Bitte prüfen: | Es gibt bereits {count} Doppelbuchungen zwischen der gesamten Wohnung und ihren Zimmern. Bitte prüfen:",
    linkedNeedsRooms: "Wählen Sie mindestens ein Zimmer aus, das in der gesamten Wohnung enthalten ist.",
    linkedSaveError: "Die Einstellungen der gesamten Wohnung konnten nicht gespeichert werden.",
    linkedAlertTitle: "„{unit}“ wird zur gesamten Wohnung",
    linkedAlertBody: "Wenn sie gebucht wird, schließen die von Ihnen ausgewählten Zimmer automatisch, hier und in Ihren Kanälen (Booking, Airbnb…). Und wenn eines dieser Zimmer gebucht wird, schließt diese Einheit für diese Nächte. Wird die Buchung storniert, öffnet sich alles von selbst wieder.",
    linkedPartialSave: "Die Einstellung für die gesamte Wohnung wurde gespeichert, die übrigen Regeln jedoch nicht. Bitte versuchen Sie es erneut.",
  },
  weekend: {
    title: "Preiseinstellungen",
    subtitle: "Diese Angaben gelten für jede Nacht, sofern Sie sie nicht nach Datum anpassen.",
    loading: "Einstellungen werden geladen…",
    plTitle: "Preise werden von PriceLabs verwaltet",
    plDesc1:
      "Für diese Unterkunft ist die dynamische Preisverwaltung mit PriceLabs aktiv. Die Preise werden je nach Nachfrage, Saison und Auslastung automatisch aktualisiert.",
    plDesc2: "Um die Wochenendpreise zu ändern, tun Sie dies direkt in Ihrem PriceLabs-Panel.",
    plOpen: "PriceLabs öffnen",
    basePriceTitle: "Basispreis",
    basePriceLabel: "Pro Nacht: gilt an jedem Tag",
    customization: "Anpassung",
    weekendPriceTitle: "Wochenendpreis",
    toggleOff: "Wochenendpreis deaktivieren",
    toggleOn: "Wochenendpreis aktivieren",
    appliesTo: "Gilt an:",
    weekendLabel: "Wochenende",
    infoHint: "Gilt für die nächsten <strong>500 Tage</strong> an den ausgewählten Tagen.",
    disabledText: "An Wochenendtagen gilt der Basispreis von",
    confirmTitle: "Wochenendpreis deaktivieren?",
    confirmDescPre: "Die Tage kehren automatisch zum Basispreis von",
    confirmDescPost: "zurück.",
    disabling: "Wird deaktiviert…",
    confirmDisable: "Ja, deaktivieren",
    saving: "Wird gespeichert…",
    saveChanges: "Änderungen speichern",
    diffEqual: "wie Basispreis",
    diffUp: "+{pct} % ggü. Basis",
    diffDown: "{pct} % ggü. Basis",
    loadError: "Fehler beim Laden der Preiseinstellungen",
    disableSuccess: "Wochenendpreis deaktiviert. Die Tage kehren zum Basispreis zurück.",
    disableError: "Fehler beim Deaktivieren des Wochenendpreises",
    saveSuccess: "Preise erfolgreich gespeichert",
    saveError: "Fehler beim Speichern",
  },
};
